module.exports = __webpack_public_path__ + "media/images/new_entry_icon-151067c4465e282d96d18b538301c81e.png";